<template>
	<button @click="$emit('click')">
		<slot></slot>
	</button>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import './../../styles/variables.scss';
button {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	font-size: 18px;
	min-width: 100px;
	height: 50px;
	background-color: white;
	border:none;
	border-left: 2px solid #3a3bf8;
	border-top-right-radius: 4px;
	border-bottom-right-radius: 4px;
	box-shadow: 0px 5px 10px -1px rgba(0, 0, 0, 0.25);
	color: black;
	cursor: pointer;
	transition: all 300ms;
	outline: none;

	&:hover {
	border-left: 2px solid white;
	background-color: #3a3bf8;
	color: white;
	padding-left: 50px;
	padding-right: 50px;
	}

	.dark & {
		background-color: $dark-text;

		&:hover {
			color: $dark-grey;
		}
	}
}
</style>
